// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__10Nit","main-image":"Header_main-image__F2BUB"};